module.exports = __webpack_public_path__ + "images/powerups/card-aging-icon.d33d5c107f425c21f7f3.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/powerups/card-aging-icon.svg
// module id = tWiZ
// module chunks = 0